import { useQuery } from '@tanstack/react-query';
import { useToast } from '@chakra-ui/react';
import { getHistoryById } from 'api/auth.api';

const getErrorMessage = (error, fallback) => {
  const msg = error?.response?.data?.message;
  if (typeof msg === 'string') return msg;
  if (typeof msg === 'object' && msg?.message) return msg.message;
  return fallback;
};

export const useGetHistoryById = (id, enabled = true) => {
  const toast = useToast();

  return useQuery({
    queryKey: ['getPatientHistoryByIdForAdmin', id],
    queryFn: () => getHistoryById(id),
    enabled: !!id && enabled,

    onError: (error) => {
      toast({
        title: 'Failed to load patient history',
        description: getErrorMessage(error, 'Unable to fetch patient history'),
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top-center',
      });
    },

    select: (res) => res?.data?.result,
  });
};
